
<template>
  <div>
    <b-modal size="lg" v-model="modal" no-close-on-backdrop>
      <template #modal-header>
        <h5>{{ title }}</h5>
      </template>

      <b-tabs content-class="mt-3">
        <b-tab>
          <template #title>
            <i class="fas fa-user-cog mr-2" />
            <strong>Dados do Usuário</strong>
          </template>

          <div class="container-fluid">
            <!-- form  -->
            <div class="row">
              <div class="col-md-12">
                <text-input
                  :alias="form.name.alias"
                  v-model="form.name.value"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <text-input
                  :alias="form.email.alias"
                  v-model="form.email.value"
                />
              </div>
            </div>

            <template>
              <div class="row">
                <div class="col-md-6">
                  <password-input
                    :alias="form.password.alias"
                    v-model="form.password.value"
                  />
                </div>
                <div class="col-md-6">
                  <password-input
                    :alias="form.password_confirmation.alias"
                    v-model="form.password_confirmation.value"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <person-select
                    v-model="form.salesman.value"
                    person-type="s"
                  />
                </div>
              </div>
            </template>
            <template v-if="this.$store.state.user.is_master_user == 1">
              <br />
              <div class="row">
                <div class="col-md-12">
                  <b-form-checkbox
                    switch
                    v-model="form.is_admin_user.value"
                    :value="1"
                    :unchecked-value="0"
                  >
                    <span style="cursor: pointer"
                      >Este usuário é administrador?</span
                    >
                  </b-form-checkbox>
                  <b-form-checkbox
                    switch
                    v-model="form.status.value"
                    :value="1"
                    :unchecked-value="0"
                  >
                    <span style="cursor: pointer">{{
                      form.status.text[form.status.value]
                    }}</span>
                  </b-form-checkbox>
                </div>
              </div>
              <hr />
              <br />
            </template>
            <!-- --------------------------------------------- -->

            <div class="row">
              <div class="col-md-10">
                <h5 class="text-primary">
                  <i class="fas fa-users" /> Permissões Cadastro de Pessoas
                </h5>
              </div>
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.personIndex"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer"
                  >Permissão para visualizar clientes e fornecedores?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.personCreateEdit"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer">
                  Permissão para cadastrar e atualizar clientes e fornecedores?
                </span></b-form-checkbox
              >
            </div>

            <hr />
            <br />
            <div class="row">
              <div class="col-md-10">
                <h5 class="text-primary">
                  <i class="fas fa-box" /> Permissões cadastro de produtos
                </h5>
              </div>
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.productIndex"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer"
                  >Permissão para visualizar produtos?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.productCreateEdit"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer"
                  >Permissão para cadastrar e atualizar produtos?
                </span></b-form-checkbox
              >
            </div>

            <hr />
            <br />
            <div class="row">
              <div class="col-md-7">
                <h5 class="text-primary">
                  <i class="fas fa-shopping-cart" /> Permissões nas vendas
                </h5>
              </div>
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.orderIndex"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer"
                  >Permissão para visualizar vendas?
                </span></b-form-checkbox
              >
            </div>

            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.orderCreateEdit"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer">
                  Permissão para fazer vendas?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.orderCancel"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer">
                  Permissão para cancelar vendas?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.orderReport"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer"
                  >Permissão para visualizar relatórios de vendas?
                </span></b-form-checkbox
              >
            </div>
            <hr />
            <br />
            <div class="row">
              <div class="col-md-10">
                <h5 class="text-primary">
                  <i class="fas fa-boxes" /> Permissões controle estoque
                </h5>
              </div>
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.stockTransactionIndex"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer"
                  >Permissão para visualizar controle de estoque?
                </span></b-form-checkbox
              >
            </div>

            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.stockTransactionCancel"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer">
                  Permissão para cancelar movimentos de estoque?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.stockTransactionCreateEdit"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer">
                  Permissão para realizar transações de ajuste de estoque?
                </span></b-form-checkbox
              >
            </div>
            <hr />
            <br />
            <div class="row">
              <div class="col-md-10">
                <h5 class="text-primary">
                  <i class="fas fa-file-invoice-dollar" />
                  Permissões contas a receber
                </h5>
              </div>
            </div>

            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.billReceiveIndex"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer"
                  >Permissão para visualizar o crediário?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.billReceiveCreateEdit"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer">
                  Permissão para receber contas no crediário?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.billReceiveCancel"
                :value="1"
                :unchecked-value="0"
                ><span style="cursor: pointer">
                  Permissão para cancelar notas do crediário?
                </span></b-form-checkbox
              >
            </div>

            <hr />
            <br />
            <div class="row">
              <div class="col-md-10">
                <h5 class="text-primary">
                  <i class="fas fa-file-invoice-dollar" /> Permissões contas a
                  pagar
                </h5>
              </div>
            </div>

            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.billPaymentCreateEdit"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer"
                  >Permissão para pagar contas de fornecedores?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.billPaymentCancel"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer"
                  >Permissão para cancelar contas de fornecedores?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.billPaymentIndex"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer"
                  >Permissão para visualizar os pagamentos a fornecedores?
                </span></b-form-checkbox
              >
            </div>

            <hr />
            <br />
            <div class="row">
              <div class="col-md-7">
                <h5 class="text-primary">
                  <i class="fas fa-coins" /> Permissões dos Caixas
                </h5>
              </div>
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.accountTransactionIndex"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer"
                  >Permissão para visualizar os caixas e contas bancárias?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.accountTransactionCreateEdit"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer"
                  >Permissão para realizar transações no caixa?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.accountTransactionCancel"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer"
                  >Permissão para cancelar movimento de caixa?
                </span></b-form-checkbox
              >
            </div>

            <hr />
            <br />
            <div class="row">
              <div class="col-md-7">
                <h5 class="text-primary">
                  <i class="fas fa-dolly-flatbed" /> Permissões controle de
                  Compras
                </h5>
              </div>
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.purchaseIndex"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer"
                  >Permissão para visualizar compras?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.purchaseCreateEdit"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer"
                  >Permissão para realizar transações de compras?
                </span></b-form-checkbox
              >
            </div>
            <div row>
              <b-form-checkbox
                switch
                v-model="userPermission.purchaseCancel"
                :value="1"
                :unchecked-value="0"
              >
                <span style="cursor: pointer"
                  >Permissão para cancelar compras?
                </span></b-form-checkbox
              >
            </div>

            <div class="row">
              <div class="col-md-12">
                <error-handler :error="error" />
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab v-if="form.id.value" @click="getActivities($event)">
          <template #title>
            <i class="fas fa-user-clock mr-2" />
            <strong>Atividades do Usuário</strong>
          </template>
          <user-timeline-activities
            @selectLog="openDetails($event)"
            @pagechange="getActivities($event)"
            ref="userTimelineActivities"
          />
        </b-tab>
      </b-tabs>

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="modal = false"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    </b-modal>
    <activity-details ref="activityDetails" />
  </div>
</template>

 <script>
import Form from "../../../mixins/Form";

import activityDetails from "../../activities/modals/activityDetails.vue";
import userTimelineActivities from "../../activities/lists/userTimelineActivities";
import PersonSelect from "@/components/person/inputs/PersonSelect";

export default {
  components: {
    activityDetails,
    userTimelineActivities,
    PersonSelect,
  },
  data() {
    return {
      error: null,
      title: null,
      modal: false,

      form: new Form({
        id: {},

        salesman: {
          value: null,
        },

        name: {
          alias: "Nome",
          validate: { required: true },
        },

        email: {
          alias: "Email",
          validate: { required: true },
        },

        password: {
          alias: "Senha",
        },

        password_confirmation: {
          alias: "Confirme a sua senha",
        },

        is_master_user: {
          default: 0,
        },

        is_admin_user: {
          default: 0,
        },

        status: {
          alias: "Status",
          default: 1,
          text: {
            1: "Este cadastro está ativo",
            0: "Este cadastro está inativo",
          },
        },
      }),

      userPermission: {},

      baseUserPermission: {
        //person
        personIndex: 0,
        personCreateEdit: 0,
        //product
        productIndex: 0,
        productCreateEdit: 0,
        //order
        orderIndex: 0,
        orderCreateEdit: 0,
        orderCancel: 0,
        orderReport: 0,
        //stock
        stockTransactionIndex: 0,
        stockTransactionCreateEdit: 0,
        stockTransactionCancel: 0,
        //billReceive
        billReceiveIndex: 0,
        billReceiveCreateEdit: 0,
        billReceiveCancel: 0,
        //billPayment
        billPaymentIndex: 0,
        billPaymentCreateEdit: 0,
        billPaymentCancel: 0,
        //accountTransaction
        accountTransactionIndex: 0,
        accountTransactionCreateEdit: 0,
        accountTransactionCancel: 0,
        // users
        canManagerUserIndex: 0,
        canManagerShopIndex: 0,
        //purchase
        purchaseIndex: 0,
        purchaseCreateEdit: 0,
        purchaseCancel: 0,
      },
    };
  },
  computed: {},
  methods: {
    open(user) {
      this.$store.commit("showLoading");
      this.form.reset();
      this.userPermission = JSON.parse(JSON.stringify(this.baseUserPermission));
      if (user) {
        axios
          .get("api/user/" + user.id)
          .then((response) => {
            this.title = "Atualizar Usuário";
            this.setFormData(response.data);
            this.form.setValues(user);
            this.modal = true;
            this.$store.commit("hideLoading");
            return;
          })
          .catch((error) => {
            this.$store.commit("hideLoading");
            this.error = error;
            this.modal = false;
          });
      }
      this.title = "Novo Usuário";
      this.$store.commit("hideLoading");
      this.modal = true;
    },

    getActivities(page = 1) {
      this.$store.commit("showLoading");
      this.$store
        .dispatch("activity/getActivities", {
          id: this.form.id.value,
          page: page,
        })
        .then((response) => {
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
        });
    },

    openDetails(activity) {
      this.$refs.activityDetails.open(activity);
    },

    setFormData(data) {
      this.form.salesman.value = data.user.salesman;

      for (let index in data.userPermission) {
        this.userPermission[data.userPermission[index].permission] =
          data.userPermission[index].has_permission;
      }
    },

    store() {
      this.error = null;

      this.$store.commit("showLoading");

      var url = "api/user/store";

      var message = "Um novo usuàrio foi cadastrado";

      if (this.form.id.value) {
        url = url + "/" + this.form.id.value;

        message = "O cadastro de " + this.form.name.value + " foi atualizado!";
      }

      axios
        .post(url, {
          ...this.form.getValues(),
          ...{ userPermission: this.userPermission },
        })
        .then((response) => {
          this.modal = false;

          this.$emit("stored");

          this.$store.commit("showAlert", {
            message: message,
            type: "success",
          });

          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.error = error;

          this.$store.commit("hideLoading");
        });
    },
  },
};
</script>

<style>
</style>




